module.exports = __webpack_public_path__ + "img/block_default_01.5dd5d8bf.png";